
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;

    class Hypoxia extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://resourcewatch.org/embed/widget/f676cdcb-3ec1-4993-a45b-079e2f68121d'
        };
    }

    render() {
        return (
            <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default Hypoxia;